/*
  * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
  * SPDX-License-Identifier: MIT
  *
  * Licensed under the MIT License. See the LICENSE accompanying this file
  * for the specific language governing permissions and limitations under
  * the License.
  */

import React from 'react';
import { connect } from 'react-redux';
import { setLang, setAuth } from '../../redux/actions';

import { I18n } from '@aws-amplify/core';

import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import { Branding } from '../../branding';
import logoDark from '../../assets/Logos/logo-dark.png';
import useWindowDimensions from '../../components/ViewPort/useWindowDimensions';

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		marginBottom: theme.spacing(6),
	},
	title: {
		flexGrow: 1,
	},
	logo: {
		width: 50,
		marginRight: theme.spacing(2),

	},
	logoutButton: {
		marginLeft: 'auto',
		backgroundColor: Branding.negative,
		color: Branding.white,
		'&:hover': {
			backgroundColor: Branding.negative,
			opacity: Branding.opacityHover,
		},
	},
	offset: theme.mixins.toolbar,
}));

const mapStateToProps = (state) => {
	return {
		lang: state.app.lang,
		auth: state.app.auth,
	}
}

const Header = (props) => {
	const classes = useStyles();

	const { width } = useWindowDimensions();

	return (
		<div className={classes.root}>
			<AppBar position="fixed" color="primary" >
				<Toolbar>
					<img alt="" src={logoDark} className={classes.logo} />

					{(width > 610) && (
						<Typography variant="h5" className={classes.title}>
							{Branding.appName}
						</Typography>
					)}

					{props.auth && (
						<Button
							href="/logout"
							variant="contained"
							className={classes.logoutButton}
							>
							{I18n.get("LOGOUT_BUTTON_LABEL")}
						</Button>
					)}
				</Toolbar>
			</AppBar>

			<div className={classes.offset} />
		</div>
	);
}

export default connect(mapStateToProps, { setLang, setAuth })(Header)
